/* eslint-disable no-unused-vars */

<template>
  <div class="fixed inset-0 z-10 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0"
    >
      <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span
      >&#8203;
      <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
      <div
        :class="showDishes ? 'sm:max-w-3xl' : 'sm:max-w-lg'"
        class="inline-block px-4 pt-5 pb-4 overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:w-full sm:p-6"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <div class="absolute top-0 right-0 hidden pt-4 pr-4 sm:block">
          <button
            @click="close"
            type="button"
            class="text-gray-400 transition duration-150 ease-in-out hover:text-gray-500 focus:outline-none focus:text-gray-500"
            aria-label="Close"
          >
            <svg
              class="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div class="grid gap-6" :class="showDishes ? 'grid-cols-2' : ''">
          <div class="w-full sm:flex sm:items-start">
            <div class="w-full mt-3 text-center sm:mt-0 sm:text-left">
              <h3
                class="text-lg font-medium leading-6 text-gray-900"
                id="modal-headline"
              >
                <span v-if="order_action == 'create_order'">
                  Crea ordine
                </span>

                <span v-else>
                  Modifica ordine
                </span>
                -
                <span class="text-sm font-medium leading-5 text-indigo-600">
                  {{ orderType.name }}</span
                >
              </h3>
              <div class="mt-2">
                <div class="flex flex-wrap -mx-2">
                  <div class="w-1/2 px-2">
                    <label
                      for="delivery_name"
                      class="block text-sm font-medium leading-5 text-gray-900"
                    >
                      <span
                        v-if="
                          orderType.slug == 'tavolo-hotel' ||
                            orderType.slug == 'tavolo' ||
                            orderType.slug == 'umbrella'
                        "
                      >
                        Data ordine*
                      </span>
                      <span v-else>
                        Data di consegna*
                      </span>
                    </label>
                    <div class="relative rounded-md shadow-sm">
                      <date-picker
                        format="DD-MM-YYYY"
                        :default-value="new Date()"
                        v-model="order.date"
                        :lang="lang"
                        id="delivery_name"
                        class="block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                      ></date-picker>
                    </div>
                  </div>
                  <div class="w-1/2 px-2">
                    <label
                      :class="
                        orderType.slug != 'tavolo-hotel' &&
                        orderType.slug != 'tavolo' &&
                        orderType.slug != 'umbrella'
                          ? ''
                          : 'hidden'
                      "
                      for="delivery_time_slot"
                      class="block text-sm font-medium leading-5 text-gray-900"
                    >
                      Orario*
                    </label>
                    <div
                      :class="
                        orderType.slug != 'tavolo-hotel' &&
                        orderType.slug != 'tavolo' &&
                        orderType.slug != 'umbrella'
                          ? ''
                          : 'hidden'
                      "
                      class="relative max-w-full rounded-md shadow-sm"
                    >
                      <date-picker
                        v-model="order.time_slot"
                        :time-picker-options="{
                          start: '07:30',
                          step: '00:15',
                          end: '23:45',
                        }"
                        format="HH:mm"
                        type="time"
                        placeholder="HH:mm"
                      ></date-picker>

                      <!--
                    <input  v-model="order.time_slot" id="delivery_time_slot" class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5">
                    --></div>
                  </div>
                  <p
                    class="px-2 mt-1 text-xs text-red-600"
                    v-if="formErrors.order_date"
                  >
                    {{ formErrors.order_date[0] }}
                  </p>
                </div>

                <div class="">
                  <div
                    v-if="orderType.slug == 'tavolo-hotel'"
                    class="flex flex-wrap mt-3 -mx-2"
                  >
                    <div class="w-1/2 px-2 ">
                      <label
                        for="delivery_room"
                        class="block text-sm font-medium leading-5 text-gray-900"
                      >
                        Camera*
                      </label>
                      <div class="relative rounded-md shadow-sm">
                        <input
                          :class="formErrors.room ? 'border-red-300' : ''"
                          v-model="order.room"
                          id="delivery_room"
                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                        />
                      </div>
                      <p
                        class="mt-1 text-xs text-red-600"
                        v-if="formErrors.room"
                      >
                        {{ formErrors.room[0] }}
                      </p>
                    </div>
                    <div class="w-1/2 px-2">
                      <label
                        for="state"
                        class="block text-sm font-medium leading-5 text-gray-700"
                        >Pasto*</label
                      >
                      <select
                        v-model="order.menu_type_id"
                        name="state"
                        id="state"
                        class="block w-full transition duration-150 ease-in-out form-select sm:text-sm sm:leading-5"
                      >
                        <option
                          v-for="menuType in menuTypes"
                          v-bind:value="menuType.id"
                          :key="menuType.id"
                        >
                          {{ menuType.name }}
                        </option>
                      </select>
                      <p
                        class="mt-1 text-xs text-red-600"
                        v-if="formErrors.menu_type_id"
                      >
                        {{ formErrors.menu_type_id[0] }}
                      </p>
                    </div>
                  </div>

                  <div
                    class="w-full mt-3"
                    v-if="orderType.slug == 'roomservice'"
                  >
                    <label
                      for="delivery_room"
                      class="block text-sm font-medium leading-5 text-gray-900"
                    >
                      Camera*
                    </label>
                    <div class="relative rounded-md shadow-sm">
                      <input
                        :class="formErrors.room ? 'border-red-300' : ''"
                        v-model="order.room"
                        id="delivery_room"
                        class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                      />
                    </div>
                    <p class="mt-1 text-xs text-red-600" v-if="formErrors.room">
                      {{ formErrors.room[0] }}
                    </p>
                  </div>

                  <div
                    v-if="
                      orderType.slug == 'tavolo' || orderType.slug == 'umbrella'
                    "
                  >
                    <div class="w-full px-2 mt-3">
                      <label
                        v-if="orderType.slug == 'tavolo'"
                        for="delivery_table_name"
                        class="block text-sm font-medium leading-5 text-gray-900"
                      >
                        Tavolo*
                      </label>
                      <label
                        v-if="orderType.slug == 'umbrella'"
                        for="delivery_table_name"
                        class="block text-sm font-medium leading-5 text-gray-900"
                      >
                        Ombrellone*
                      </label>
                      <div class="relative rounded-md shadow-sm">
                        <input
                          :class="formErrors.table_name ? 'border-red-300' : ''"
                          v-model="order.table_name"
                          id="delivery_table_name"
                          class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                        />
                      </div>
                      <p
                        class="mt-1 text-xs text-red-600"
                        v-if="formErrors.table_name"
                      >
                        {{ formErrors.table_name[0] }}
                      </p>
                    </div>
                  </div>

                  <div class="w-full mt-3">
                    <label
                      for="delivery_note"
                      class="block text-sm font-medium leading-5 text-gray-900"
                    >
                      Note ordine
                    </label>
                    <div class="relative rounded-md shadow-sm">
                      <input
                        :class="formErrors.note ? 'border-red-300' : ''"
                        v-model="order.note"
                        id="delivery_note"
                        class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                      />
                    </div>
                    <p class="mt-1 text-xs text-red-600" v-if="formErrors.note">
                      {{ formErrors.note[0] }}
                    </p>
                  </div>
                </div>

                <div
                  class="mt-2"
                  v-if="
                    order_action == 'create_order' &&
                      orderType.slug != 'tavolo-hotel'
                  "
                >
                  <label
                    for="state"
                    class="block text-sm font-medium leading-5 text-gray-700"
                    >Stato ordine</label
                  >
                  <select
                    v-model="order.order_status_id"
                    name="state"
                    id="state"
                    class="block w-full mt-1 transition duration-150 ease-in-out form-select sm:text-sm sm:leading-5"
                  >
                    <option
                      v-for="status in statuses"
                      v-bind:value="status.id"
                      :key="status.id"
                    >
                      {{ status.name }}
                    </option>
                  </select>
                </div>

                <div class="py-2 border-b border-gray-400">
                  <nav class="flex">
                    <span
                      :class="
                        currentTab == 'dishes'
                          ? 'text-indigo-700 bg-indigo-100 '
                          : 'bg-gray-50'
                      "
                      @click="selectTab('dishes')"
                      class="px-3 py-2 text-sm font-medium leading-5 border rounded-md cursor-pointer"
                    >
                      Piatti
                    </span>
                    <span
                      v-if="
                        orderType.slug == 'asporto' ||
                          orderType.slug == 'domicilio'
                      "
                      :class="
                        currentTab == 'client'
                          ? 'text-indigo-700 bg-indigo-100 '
                          : 'bg-gray-50'
                      "
                      @click="selectTab('client')"
                      class="px-3 py-2 ml-4 text-sm font-medium leading-5 border rounded-md cursor-pointer"
                    >
                      Info Cliente
                    </span>
                  </nav>
                  <span
                    v-if="
                      formErrors.name ||
                        formErrors.surname ||
                        formErrors.phone ||
                        formErrors.email ||
                        formErrors.city ||
                        formErrors.zip ||
                        formErrors.street ||
                        formErrors.house_number
                    "
                    class="text-sm text-red-600"
                  >
                    Correggi gli errori nelle info cliente
                  </span>
                </div>

                <div class="flex flex-wrap -mx-2" v-if="currentTab == 'client'">
                  <div class="w-1/2 px-2 mt-3">
                    <label
                      for="delivery_name"
                      class="block text-sm font-medium leading-5 text-gray-900"
                    >
                      Nome*
                    </label>
                    <div class="relative rounded-md shadow-sm">
                      <input
                        :class="formErrors.name ? 'border-red-300' : ''"
                        v-model="order.name"
                        id="delivery_name"
                        class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                      />
                    </div>
                    <p class="mt-1 text-xs text-red-600" v-if="formErrors.name">
                      {{ formErrors.name[0] }}
                    </p>
                  </div>
                  <div class="w-1/2 px-2 mt-3">
                    <label
                      for="delivery_surname"
                      class="block text-sm font-medium leading-5 text-gray-900"
                    >
                      Cognome*
                    </label>
                    <div class="relative rounded-md shadow-sm">
                      <input
                        :class="formErrors.surname ? 'border-red-300' : ''"
                        v-model="order.surname"
                        id="delivery_surname"
                        class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                      />
                    </div>
                    <p
                      class="mt-1 text-xs text-red-600"
                      v-if="formErrors.surname"
                    >
                      {{ formErrors.surname[0] }}
                    </p>
                  </div>
                  <div class="w-1/2 px-2 mt-3">
                    <label
                      for="delivery_phone"
                      class="block text-sm font-medium leading-5 text-gray-900"
                    >
                      Telefono*
                    </label>
                    <div class="relative rounded-md shadow-sm">
                      <input
                        :class="formErrors.phone ? 'border-red-300' : ''"
                        v-model="order.phone"
                        id="delivery_phone"
                        class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                      />
                    </div>
                    <p
                      class="mt-1 text-xs text-red-600"
                      v-if="formErrors.phone"
                    >
                      {{ formErrors.phone[0] }}
                    </p>
                  </div>
                  <div class="w-1/2 px-2 mt-3">
                    <label
                      for="delivery_email"
                      class="block text-sm font-medium leading-5 text-gray-900"
                    >
                      Email*
                    </label>
                    <div class="relative rounded-md shadow-sm">
                      <input
                        :class="formErrors.email ? 'border-red-300' : ''"
                        v-model="order.email"
                        id="delivery_email"
                        class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                      />
                    </div>
                    <p
                      class="mt-1 text-xs text-red-600"
                      v-if="formErrors.email"
                    >
                      {{ formErrors.email[0] }}
                    </p>
                  </div>
                  <div
                    class="w-2/3 px-2 mt-3"
                    v-if="orderType.slug == 'domicilio'"
                  >
                    <label
                      for="delivery_city"
                      class="block text-sm font-medium leading-5 text-gray-900"
                    >
                      Comune*
                    </label>
                    <div class="relative rounded-md shadow-sm">
                      <input
                        :class="formErrors.city ? 'border-red-300' : ''"
                        v-model="order.city"
                        id="delivery_city"
                        class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                      />
                    </div>
                    <p class="mt-1 text-xs text-red-600" v-if="formErrors.city">
                      {{ formErrors.city[0] }}
                    </p>
                  </div>
                  <div
                    class="w-1/3 px-2 mt-3"
                    v-if="orderType.slug == 'domicilio'"
                  >
                    <label
                      for="delivery_zip"
                      class="block text-sm font-medium leading-5 text-gray-900"
                    >
                      Cap*
                    </label>
                    <div class="relative rounded-md shadow-sm">
                      <input
                        :class="formErrors.zip ? 'border-red-300' : ''"
                        v-model="order.zip"
                        id="delivery_zip"
                        class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                      />
                    </div>
                    <p class="mt-1 text-xs text-red-600" v-if="formErrors.zip">
                      {{ formErrors.zip[0] }}
                    </p>
                  </div>
                  <div
                    class="w-2/3 px-2 mt-3"
                    v-if="orderType.slug == 'domicilio'"
                  >
                    <label
                      for="delivery_street"
                      class="block text-sm font-medium leading-5 text-gray-900"
                    >
                      Via*
                    </label>
                    <div class="relative rounded-md shadow-sm">
                      <input
                        :class="formErrors.street ? 'border-red-300' : ''"
                        v-model="order.street"
                        id="delivery_street"
                        class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                      />
                    </div>
                    <p
                      class="mt-1 text-xs text-red-600"
                      v-if="formErrors.street"
                    >
                      {{ formErrors.street[0] }}
                    </p>
                  </div>
                  <div
                    class="w-1/3 px-2 mt-3"
                    v-if="orderType.slug == 'domicilio'"
                  >
                    <label
                      for="delivery_house_number"
                      class="block text-sm font-medium leading-5 text-gray-900"
                    >
                      Civico*
                    </label>
                    <div class="relative rounded-md shadow-sm">
                      <input
                        :class="formErrors.house_number ? 'border-red-300' : ''"
                        v-model="order.house_number"
                        id="delivery_house_number"
                        class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                      />
                    </div>
                    <p
                      class="mt-1 text-xs text-red-600"
                      v-if="formErrors.house_number"
                    >
                      {{ formErrors.house_number[0] }}
                    </p>
                  </div>
                  <div
                    class="w-full px-2 mt-3"
                    v-if="orderType.slug == 'domicilio'"
                  >
                    <label
                      for="delivery_note"
                      class="block text-sm font-medium leading-5 text-gray-900"
                    >
                      Note consegna
                    </label>
                    <div class="relative rounded-md shadow-sm">
                      <textarea
                        :class="
                          formErrors.delivery_note ? 'border-red-300' : ''
                        "
                        v-model="order.delivery_note"
                        id="delivery_note"
                        rows="4"
                        class="block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5"
                      ></textarea>
                    </div>
                    <p
                      class="mt-1 text-xs text-red-600"
                      v-if="formErrors.delivery_note"
                    >
                      {{ formErrors.delivery_note[0] }}
                    </p>
                  </div>
                </div>

                <div class="flex flex-wrap" v-if="currentTab == 'dishes'">
                  <ul class="w-full divide-y divide-gray-400">
                    <li
                      v-if="order.order_detail.length == 0"
                      class="mt-2 text-xs"
                    >
                      Nessun piatto inserito
                    </li>
                    <li
                      v-for="dish in order.order_detail"
                      :key="order.id + '_' + dish.dish_id"
                      class="py-2"
                    >
                      <div class="flex flex-wrap items-center">
                        <span class="text-sm">
                          <div>
                            <div class="flex items-center">
                              <button @click="removeQuantity(order, dish)">
                                <svg
                                  class="w-6 h-6 fill-current "
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 512 512"
                                >
                                  <g data-name="Raggruppa 2">
                                    <g data-name="Raggruppa 1">
                                      <path
                                        data-name="Tracciato 1"
                                        d="M256 0C114.833 0 0 114.833 0 256s114.833 256 256 256 256-114.853 256-256S397.167 0 256 0zm0 472.341C136.725 472.341 39.659 375.3 39.659 256S136.725 39.659 256 39.659 472.341 136.705 472.341 256 375.3 472.341 256 472.341z"
                                      />
                                    </g>
                                  </g>
                                  <g data-name="Raggruppa 4">
                                    <g data-name="Raggruppa 3">
                                      <path
                                        data-name="Tracciato 2"
                                        d="M355.148 234.386h-198.3a19.83 19.83 0 000 39.66h198.3a19.83 19.83 0 000-39.66z"
                                      />
                                    </g>
                                  </g>
                                </svg>
                              </button>
                              <span
                                class="ml-2 mr-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium leading-4 bg-indigo-100 "
                              >
                                {{ dish.qty }}
                              </span>
                              <button @click="addQuantity(order, dish)">
                                <svg
                                  class="w-6 h-6 fill-current "
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 512 512"
                                >
                                  <path
                                    d="M256 0C114.833 0 0 114.833 0 256s114.833 256 256 256 256-114.853 256-256S397.167 0 256 0zm0 472.341c-119.275 0-216.341-97.046-216.341-216.341S136.725 39.659 256 39.659 472.341 136.705 472.341 256 375.295 472.341 256 472.341z"
                                  />
                                  <path
                                    d="M355.148 234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83 8.884-19.83 19.83v79.318h-79.318c-10.966 0-19.83 8.884-19.83 19.83s8.864 19.83 19.83 19.83h79.318v79.318c0 10.946 8.864 19.83 19.83 19.83s19.83-8.884 19.83-19.83v-79.318h79.318c10.966 0 19.83-8.884 19.83-19.83s-8.864-19.83-19.83-19.83z"
                                  />
                                </svg>
                              </button>

                              <span class="mx-2">{{ dish.name }}</span>

                              <button
                                class="ml-4"
                                @click="deleteDish(order, dish)"
                              >
                                <svg
                                  class="w-6 h-6 fill-current "
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    class="heroicon-ui"
                                    d="M8 6V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2h5a1 1 0 0 1 0 2h-1v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8H3a1 1 0 1 1 0-2h5zM6 8v12h12V8H6zm8-2V4h-4v2h4zm-4 4a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1z"
                                  />
                                </svg>
                              </button>

                              <button
                                v-if="dish.comment == undefined"
                                class="ml-4"
                                @click="addComment(dish)"
                              >
                                <svg
                                  class="w-6 h-6 text-gray-600 fill-current "
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  width="24"
                                  height="24"
                                >
                                  <path
                                    class="heroicon-ui"
                                    d="M8 4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h2zm0 2H6v14h12V6h-2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2zm2-2v2h4V4h-4z"
                                  />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </span>
                      </div>
                      <div v-if="dish.comment != undefined" class="w-full">
                        <span
                          class="mt-1 w-full inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium leading-4 bg-red-100 text-red-800"
                        >
                          <input
                            placeholder="Scrivi qui una nota per il piatto"
                            v-model="dish.comment"
                            type="text"
                            class="w-full p-1 bg-transparent focus:outline-none"
                          />
                        </span>
                      </div>
                    </li>
                  </ul>
                  <p
                    @click="addDishes()"
                    class="mt-2 text-sm font-medium text-indigo-700 cursor-pointer"
                    v-if="!showDishes"
                  >
                    Aggiungi piatto
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div v-if="showDishes">
            <div class="relative ">
              <div
                class="mr-2 bg-gray-100 border-t-2 border-b-4 border-gray-100"
              >
                <div
                  class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
                >
                  <svg
                    class="w-5 h-5 text-gray-400"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      class="heroicon-ui"
                      d="M16.32 14.9l5.39 5.4a1 1 0 01-1.42 1.4l-5.38-5.38a8 8 0 111.41-1.41zM10 16a6 6 0 100-12 6 6 0 000 12z"
                    />
                  </svg>
                </div>
                <input
                  v-model="search"
                  class="block w-full pl-10 form-input sm:text-sm sm:leading-5"
                  placeholder="Cerca"
                />
              </div>
            </div>

            <ul>
              <li v-for="category in filterCategory" :key="category.id">
                <div
                  class="mt-0.5 text-sm font-bold leading-5 tracking-wide text-gray-500 uppercase lg:text-xs"
                >
                  {{ category.name }}
                </div>
                <ul class="p-2">
                  <li
                    v-for="dish in category.dishes"
                    :key="dish.id"
                    class="relative mb-1"
                  >
                    <div class="text-sm leading-5">
                      <label
                        :for="'list_dish_' + dish.id"
                        class="font-normal text-gray-700"
                        >{{ dish.name }}
                        <span v-if="dish.price"
                          >- {{ dish.price }}{{ dish.unit }}
                        </span>
                        <span
                          class="mr-1 text-xs text-indigo-700 cursor-pointer"
                          @click="addDish(dish)"
                          >Aggiungi</span
                        >
                      </label>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>

        <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
          <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button
              @click="action"
              type="button"
              class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-white bg-green-400 border rounded-md shadow-sm border-gray-50 hover:text-gray-50 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5 hover:bg-green-500 focus:border-green-400 focus:shadow-outline-green"
            >
              Salva
            </button>
          </span>
          <span class="flex w-full mt-3 rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <button
              type="button"
              @click="close"
              class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
            >
              Annulla
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/it";
import { format } from "date-fns";
import MenuService from "./../apis/MenuService";

export default {
  name: "ModalOrder",
  components: {
    DatePicker,
  },
  props: {
    initialOrder: {
      type: Object,
      required: true,
    },
    locationId: {
      type: String,
    },
    formErrors: {
      type: Object,
    },
    types: {
      type: Array,
      required: true,
    },
    menuTypes: {
      type: Array,
      required: true,
    },
    statuses: {
      type: Array,
      required: true,
    },
    event: {
      type: String,
      default: "",
    },
    eventclose: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      order: JSON.parse(JSON.stringify(this.initialOrder)),
      currentTab: "dishes",
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      categories: [],
      allergens: [],
      attributes: [],
      showDishes: false,
      search: "",
      orderType: "",
      order_action: "",
    };
  },
  methods: {
    addDish(dish) {
      let index = this.order.order_detail.findIndex(
        (x) => x.dish_id === dish.id
      );
      if (index != -1 && index != undefined) {
        this.order.order_detail[index].qty =
          this.order.order_detail[index].qty + 1;
      } else {
        this.order.order_detail.push({
          dish_id: dish.id,
          price: dish.price,
          qty: 1,
          unit: dish.unit,
          name: dish.name,
          comment: null,
        });
      }
    },

    addDishes() {
      this.$store.dispatch("updateSpinner", true);

      MenuService.dishesList(this.locationId).then((response) => {
        this.categories = response.data.data.categories;
        this.allergens = response.data.data.allergens;
        this.attributes = response.data.data.attributes;

        this.showDishes = true;

        this.$store.dispatch("updateSpinner", false);
      });
    },

    getOrderType(typeid) {
      let s = this.types.find((type) => type.id == typeid);
      if (s) {
        this.orderType = s;
      }

      /*
        if(s.length > 0){
            this.orderTypeSlug = s[0].slug;
            return s[0].name;
        }
        return '';
        */
    },

    addQuantity(order, dish) {
      dish.qty++;
    },

    removeQuantity(order, dish) {
      if (dish.qty > 0) {
        dish.qty--;
      }
    },

    deleteDish(order, dish) {
      order.order_detail = order.order_detail.filter(
        (x) => x.dish_id !== dish.dish_id
      );
    },

    addComment(dish) {
      dish.comment = "";
    },

    selectTab: function(tabname) {
      this.currentTab = tabname;
    },

    close: function() {
      this.$root.$emit(this.eventclose);
    },

    action: function() {
      this.order.order_date =
        this.order.date && this.order.time_slot
          ? format(this.order.date, "yyyy-MM-dd") +
            " " +
            format(this.order.time_slot, "HH:mm")
          : "";
      this.$root.$emit(this.event, this.order);
    },
  },
  mounted: function() {
    let date;
    if (this.order.action != undefined && this.order.action == "create_order") {
      this.order_action = "create_order";
      date = new Date();
      this.order.order_status_id = this.statuses[0].id;
    } else {
      date = new Date(Date.parse(this.order.order_date));
    }

    this.$set(this.order, "date", date);
    this.$set(this.order, "time_slot", date);

    this.getOrderType(this.order.order_type_id);
  },
  computed: {
    filterCategory: function() {
      //return this.categories.filter(d => d.dishes.every(c => c.name.includes(this.search)));
      let filteredResult = JSON.parse(JSON.stringify(this.categories));
      for (let i = 0; i < filteredResult.length; i++) {
        for (let j = filteredResult[i].dishes.length - 1; j >= 0; j--) {
          if (
            !filteredResult[i].dishes[j].name
              .toLowerCase()
              .includes(this.search.toLowerCase())
          ) {
            filteredResult[i].dishes.splice(j, 1);
          }
        }
      }
      return filteredResult;
    },
  },
};
</script>

<style scoped>
.mx-datepicker {
  max-width: 100%;
}
</style>
